import { t } from "@lingui/macro";
import * as v from "valibot";

export const specificValidationRules = [
  "bic",
  "bytes",
  "creditCard",
  "cuid2",
  "custom",
  "customAsync",
  "decimal",
  "email",
  "emoji",
  "endsWith",
  "excludes",
  "finite",
  "hash",
  "hexColor",
  "hexadecimal",
  "imei",
  "includes",
  "integer",
  "ip",
  "ipv4",
  "ipv6",
  "isoDate",
  "isoDateTime",
  "isoTime",
  "isoTimeSecond",
  "isoTimestamp",
  "isoWeek",
  "length",
  "mac",
  "mac48",
  "mac64",
  "maxBytes",
  "maxLength",
  "maxSize",
  "maxValue",
  "mimeType",
  "minBytes",
  "minLength",
  "minSize",
  "minValue",
  "multipleOf",
  "notBytes",
  "notLength",
  "notSize",
  "notValue",
  "octal",
  "regex",
  "safeInteger",
  "size",
  "startsWith",
  "ulid",
  "url",
  "uuid",
  "value",
] as const;

const specificErrorMessages = {
  email: t`The email address is invalid.`,
  string: t`This field is required.`,
};

export const setupLinguiValidation = () => {
  //   v.setGlobalMessage(
  //     (issue) => t("validation.global", { issue }),
  //     i18n.language,
  //   );
  //   v.setSchemaMessage(
  //     (issue) => t("validation.schema", { issue }),
  //     i18n.language,
  //   );

  v.setSpecificMessage(v.string, specificErrorMessages.string);
  v.setSpecificMessage(v.email, specificErrorMessages.email);
};
